import { atkEquipmentApi } from "common/state/portalApi/atkEquipment";
import {
  capitalize,
  CircularProgress,
  Divider,
  Input,
  Typography,
} from "@mui/material";
import { DEBOUNCE_MS } from "portal/utils/timing";
import { StepProps } from "./StepProps";
import { TractorArchetypeChooser } from "./TractorArchetypeChooser";
import { useDebounce } from "@uidotdev/usehooks";
import { useQueryPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";
import React, { FC, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";

export const ChooseArchetypeStep: FC<StepProps> = ({ disabled }) => {
  const { t } = useTranslation();
  const [query, setQuery] = useState<string>("");
  const debouncedQuery = useDebounce(query, DEBOUNCE_MS);
  const { data: searchResult, isFetching: archetypesFetching } = useQueryPopups(
    atkEquipmentApi.endpoints.searchTractorArchetypes.useQuery({
      query: debouncedQuery,
    })
  );
  return (
    <div className="flex flex-col gap-2">
      <Typography variant="h6">
        {capitalize(
          t("views.autotractor.equipment.tractors.chooseSupportedTractor")
        )}
      </Typography>
      <Divider />
      <div className="flex gap-2">
        <Input
          fullWidth
          startAdornment={<SearchIcon />}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={t("utils.actions.search")}
        />
      </div>
      <div className="flex flex-wrap gap-4">
        {archetypesFetching && <CircularProgress variant="indeterminate" />}
        {searchResult?.archetypes.map((a) => (
          <TractorArchetypeChooser
            key={a.id}
            archetype={a}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
};
